module.exports = __webpack_public_path__ + "static/media/ico_simulation_uppper_lower_lips.2ca91f6d.png";